import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function initContactsSection(section) {
  if (section.dataset.wvAnimInited === "1") return;
  section.dataset.wvAnimInited = "1";

  const title = section.querySelector("h2.global_title");
  const items = gsap.utils.toArray(section.querySelectorAll(".item-contact"));
  const decor = section.querySelector(".wv-decor");

  // --- initial ---
  if (title) gsap.set(title, { autoAlpha: 0, y: 40 });
  gsap.set(items, { autoAlpha: 0, y: 40, scale: 0.98 });

  items.forEach((it) => {
    const img = it.querySelector("img");
    const t = it.querySelector(".item-title");
    const content = gsap.utils.toArray(it.querySelectorAll(".item-content"));

    if (img) gsap.set(img, { autoAlpha: 0, y: 10, scale: 0.9 });
    if (t) gsap.set(t, { autoAlpha: 0, y: 10 });
    if (content.length) gsap.set(content, { autoAlpha: 0, y: 10 });
  });

  if (decor) {
    const startY = 90;
    const arcX = 70;
    gsap.set(decor, { autoAlpha: 0, scale: 0.98, x: 0, y: startY });

    ScrollTrigger.create({
      trigger: section,
      start: "top 80%",
      once: true,
      onEnter: () => {
        gsap.to(decor, {
          autoAlpha: 1,
          scale: 1,
          duration: 1.6,
          ease: "power3.out",
          keyframes: [
            { x: arcX, y: startY * 0.55 },
            { x: -arcX * 0.35, y: startY * 0.25 },
            { x: 0, y: 0 },
          ],
          overwrite: "auto",
        });
      },
    });
  }

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top 65%",
      once: true,
    },
    defaults: { ease: "power3.out" },
  });

  // Title
  if (title) {
    tl.to(title, { autoAlpha: 1, y: 0, duration: 0.85 }, 0);
  }

  // Cards stagger
  items.forEach((it, i) => {
    const img = it.querySelector("img");
    const t = it.querySelector(".item-title");
    const content = gsap.utils.toArray(it.querySelectorAll(".item-content"));

    const base = 0.2 + i * 0.22;

    tl.to(
      it,
      { autoAlpha: 1, y: 0, scale: 1, duration: 0.7, ease: "power4.out" },
      base
    );

    if (img) {
      tl.to(img, { autoAlpha: 1, y: 0, scale: 1, duration: 0.45 }, base + 0.06);
    }

    if (t) {
      tl.to(t, { autoAlpha: 1, y: 0, duration: 0.45 }, base + 0.1);
    }

    if (content.length) {
      tl.to(
        content,
        { autoAlpha: 1, y: 0, duration: 0.5, stagger: 0.06 },
        base + 0.14
      );
    }
  });
}

function initAllContacts() {
  document
    .querySelectorAll(".wp-block-blocks-webvibe-block-contacts")
    .forEach(initContactsSection);

  ScrollTrigger.refresh();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initAllContacts);
} else {
  initAllContacts();
}